import React from 'react';

type Tone = 'default' | 'danger' | 'confirm' | 'cancel';

const TONE_CLASSES: Record<Tone, string> = {
  default: 'text-white/45 border-white/8 hover:text-brand-teal hover:border-brand-teal/30 hover:bg-brand-teal/7',
  danger: 'text-white/35 border-white/8 hover:text-brand-danger hover:border-brand-danger/30 hover:bg-brand-danger/7',
  confirm: 'text-brand-success border-brand-success/30 hover:bg-brand-success/10',
  cancel: 'text-brand-danger border-brand-danger/25 hover:bg-brand-danger/7',
};

export const IconActionButton = ({
  tone = 'default',
  className = '',
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { tone?: Tone }) => (
  <button
    className={`flex h-[30px] w-[30px] items-center justify-center rounded-md border bg-transparent transition-colors duration-200 cursor-pointer ${TONE_CLASSES[tone]} ${className}`}
    {...props}
  >
    {children}
  </button>
);
